import createEditAssetSubtype from '../modals/createEditAssetSubtype/lan/es';
import deleteAssetSubtype from '../modals/deleteAssetSubtype/lan/es';

export default {
    ...createEditAssetSubtype,
    ...deleteAssetSubtype,
}